import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowForwardIos = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_forward_ios" {...props} />
))

ArrowForwardIos.displayName = 'ArrowForwardIos'

export default ArrowForwardIos
